/* Update cart items */
if (!customElements.get('cart-items')) {
  class CartItems extends HTMLElement {
    constructor() {
      super();

      this.cartNotification = document.querySelector('cart-notification');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
        (total, quantityInput) => total + parseInt(quantityInput.value),
        0
      );

      this.debouncedOnChange = debounce((event) => {
        if (event.target != document.getElementById('Cart-note')) {
          this.onChange(event);
        }
      }, 300);

      this.querySelector('form').addEventListener('change', this.debouncedOnChange.bind(this));
    }

    onChange(event) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute('name')
      );
    }

    getSectionsToRender() {
      return [
        {
          id: 'main-cart-items',
          section: document.getElementById('main-cart-items').dataset.id,
          selector: '.js-cart-item-contents',
        },
        {
          id: 'main-cart-footer',
          section: document.getElementById('main-cart-footer').dataset.id,
          selector: '.js-cart-footer-contents',
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '[data-cart-icon-bubble]',
        },
      ];
    }

    updateQuantity(id, quantity, name) {
      const type =
        document.querySelector('body').classList.contains('cart-notification-is-open') &&
        this.cartNotification
          ? 'notification'
          : 'cart';

      let cartEl = type == 'cart' ? this.cartDrawer : this.cartNotification;
      if (!cartEl) {
        cartEl = document.querySelector('#MainContent');
      }

      this.enableLoading(cartEl);

      const sections =
        type == 'cart'
          ? this.getSectionsToRender().map((section) => section.section)
          : this.cartNotification.getSectionsToRender().map((section) => section.id);

      const body = JSON.stringify({
        id,
        quantity,
        sections: sections,
        sections_url: window.location.pathname,
      });

      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = parseJson(state);

          if (type == 'cart') {
            this.classList.toggle('cart-is-empty', parsedState.item_count === 0);
            this.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) ||
                document.getElementById(section.id);

              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            });
          } else {
            // close the cart notification if it will become empty
            if (
              quantity == 0 &&
              this.querySelector('[data-cart-notification-items]').querySelectorAll(
                '[data-cart-item]'
              ).length <= 1
            ) {
              this.cartNotification.close();
              this.cartNotification.getSectionsToRender().forEach((section) => {
                if (section.id == 'cart-icon-bubble') {
                  const elementToReplace =
                    document.getElementById(section.id).querySelector(section.selector) ||
                    document.getElementById(section.id);
                  elementToReplace.innerHTML = this.getSectionInnerHTML(
                    parsedState.sections[section.section],
                    section.selector
                  );
                }
              });
            } else {
              this.cartNotification.renderContents(parsedState, true);
            }
          }

          this.updateLiveRegions(id, parsedState.item_count, cartEl);
          cartEl
            .querySelector(`[data-cart-item="${id}"]`)
            ?.querySelector(`[name="${name}"]`)
            ?.focus();
          this.disableLoading(cartEl);
        })
        .catch((error) => {
          console.log(error);

          cartEl.querySelector('[data-cart-loader-active="show"]')?.classList.add('hidden');
          cartEl.querySelector('[data-cart-loader-active="hidden"]')?.classList.remove('hidden');
          cartEl.querySelector('#cart-errors').textContent = window.cartStrings.error;
          this.disableLoading(cartEl);
        });
    }

    // show error texts, should not be deleted.
    updateLiveRegions(id, itemCount, cartEl) {
      if (!cartEl) {
        return;
      }

      if (this.currentItemCount === itemCount) {
        const errorElText = cartEl
          .querySelector(`[data-cart-item-error="${id}"]`)
          ?.querySelector('.cart-item__error-text');
        const quantityEl = cartEl.querySelector(`[data-cart-item-quantity="${id}"]`);
        if (errorElText && quantityEl) {
          errorElText.innerHTML = window.cartStrings.quantityError.replace(
            '[quantity]',
            quantityEl.value
          );
        }
      }

      this.currentItemCount = itemCount;

      if (cartEl.querySelector('#shopping-cart-line-item-status')) {
        cartEl.querySelector('#shopping-cart-line-item-status').setAttribute('aria-hidden', true);
      }

      if (cartEl.querySelector('#cart-live-region-text')) {
        cartEl.querySelector('#cart-live-region-text').setAttribute('aria-hidden', false);

        setTimeout(() => {
          cartEl.querySelector('#cart-live-region-text').setAttribute('aria-hidden', true);
        }, 1000);
      }
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }

    enableLoading(cartEl) {
      if (!cartEl) {
        return;
      }

      cartEl.querySelector('cart-items').classList.add('cart-items-is-loading');
      cartEl.querySelector('[data-cart-loader-active="show"]')?.classList.remove('hidden');
      cartEl.querySelector('[data-cart-loader-active="hidden"]')?.classList.add('hidden');
      document.activeElement.blur();
      cartEl.querySelector('#shopping-cart-line-item-status')?.setAttribute('aria-hidden', true);
    }

    disableLoading(cartEl) {
      if (!cartEl) {
        return;
      }

      cartEl.querySelector('cart-items').classList.remove('cart-items-is-loading');
      cartEl.querySelector('[data-cart-loader-active="show"]')?.classList.add('hidden');
      cartEl.querySelector('[data-cart-loader-active="hidden"]')?.classList.remove('hidden');
    }
  }
  customElements.define('cart-items', CartItems);
}

/* Remove item from the cart  */
if (!customElements.get('cart-remove-button')) {
  class CartRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault();
        this.closest('[data-cart-item]').querySelector(`[data-cart-item-quantity]`).value = 0;
        this.closest('cart-items').updateQuantity(this.dataset.index, 0);
      });
    }
  }
  customElements.define('cart-remove-button', CartRemoveButton);
}

/* Update the cart note */
if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }
  customElements.define('cart-note', CartNote);
}

if (!customElements.get('cart-item-properties')) {
  class CartItemProperties extends HTMLElement {
    constructor() {
      super();

      this.querySelectorAll('[data-toggle-properties]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.toggleProperties(event);
        });
      });
    }

    toggleProperties(event) {
      const target = event.currentTarget || event.target;
      if (!target) {
        return;
      }
      const cartItem = target.closest('[data-cart-item]');
      const type = target.dataset.toggleProperties;

      cartItem.querySelectorAll('[data-property]').forEach((property, index) => {
        const addClass = index > 2 ? type != 'show' : false;
        property.classList.toggle('hidden', addClass);
      });

      cartItem.querySelectorAll('[data-toggle-properties]').forEach((button, index) => {
        const addClass = type == button.dataset.toggleProperties;
        button.classList.toggle('hidden', addClass);
      });
    }
  }
  customElements.define('cart-item-properties', CartItemProperties);
}
